import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DvButtonComponent, DvDialogContent, DvDialogContentComponent } from '@devinco/ui/dds';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-location-access-blocked-dialog',
  imports: [DvDialogContentComponent, DvButtonComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './location-access-blocked-dialog.component.html',
})
export class LocationAccessBlockedDialogComponent extends DvDialogContent<undefined> {}
